/* Affiorezuna · Wedding Planner popup
   Opens once per visit after a delay, a scroll depth or (desktop) exit intent.
   Closing snoozes it for 21 days; signing up (here, on the guide page or in the footer) stops it for good. */
(function () {
  var root = document.querySelector('[data-af-gp]');
  if (!root) return;
  var KEY = 'af-guide-popup';
  var SNOOZE_DAYS = 21;
  var DELAY_MS = 35000;
  var SCROLL_SHARE = 0.55;

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  var state = read();
  var params = new URLSearchParams(location.search);
  var posted = params.get('customer_posted') === 'true';
  var hash = location.hash;

  // Signed up through any of our forms: never offer the popup again.
  if (posted && (hash === '#af-gp-form' || hash === '#af-guide-form' || hash === '#af-news-form')) {
    state.joined = true; write(state);
  }

  var opened = false;
  function open() {
    if (opened) return;
    opened = true;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.addEventListener('keydown', onKey);
  }
  function close() {
    root.classList.remove('is-open');
    setTimeout(function () { root.hidden = true; }, 250);
    document.removeEventListener('keydown', onKey);
    state.snoozedAt = Date.now(); write(state);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  root.querySelector('[data-af-gp-close]').addEventListener('click', close);
  var form = root.querySelector('form');
  if (form) form.addEventListener('submit', function () { state.joined = true; write(state); });

  // Just signed up through the popup: show the download right away.
  if (posted && hash === '#af-gp-form') { open(); return; }

  if (state.joined) return;
  if (state.snoozedAt && Date.now() - state.snoozedAt < SNOOZE_DAYS * 864e5) return;

  var timer = setTimeout(open, DELAY_MS);
  function onScroll() {
    var max = document.documentElement.scrollHeight - innerHeight;
    if (max > 0 && scrollY / max >= SCROLL_SHARE) { window.removeEventListener('scroll', onScroll); clearTimeout(timer); open(); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  if (window.matchMedia && matchMedia('(pointer: fine)').matches) {
    document.addEventListener('mouseout', function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); clearTimeout(timer); open(); }
    });
  }
})();
